import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
import { DownOutlined } from '@ant-design/icons';
import { Drawer, Button } from 'antd';
import { useRouteMatch, useHistory } from 'react-router-dom';

import SidebarSteps from './sidebar-steps';

const Sidebar = ({ stages, currentStep }) => {
  const [open, setOpen] = useState(false);
  const { url } = useRouteMatch();
  const history = useHistory();
  const handleStepChange = (index) => {
    setOpen(false);
    history.push(`${url}/${stages[index].path}`);
  };

  return (
    <Media
      queries={{
        small: '(max-width: 699px)',
        medium: '(min-width: 700px)',
      }}
      onChange={() => setOpen(false)}
    >
      {(matches) => (
        <>
          {matches.small && (
            <>
              <Drawer
                className="steps-sidebar-drawer"
                getContainer
                placement="top"
                visible={open}
                height="100vh"
                title="Signup steps"
                maskStyle={{
                  backgroundColor: 'var(--fourth-color-01)',
                }}
                drawerStyle={{
                  backgroundColor: 'var(--fourth-color-01)',
                }}
                bodyStyle={{
                  backgroundColor: 'var(--fourth-color-01)',
                }}
                onClose={() => {
                  setOpen(false);
                }}
                closable
              >
                <SidebarSteps
                  currentStep={currentStep}
                  handleStepChange={handleStepChange}
                  stages={stages}
                />
              </Drawer>

              <Button
                type="primary"
                icon={<DownOutlined />}
                onClick={() => {
                  setOpen(true);
                }}
              >
                Signup Steps
              </Button>
            </>
          )}
          
          {matches.medium && (
            <SidebarSteps
              currentStep={currentStep}
              handleStepChange={handleStepChange}
              stages={stages}
            />
          )}
        </>
      )}
    </Media>
  );
};

Sidebar.propTypes = {
  stages: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      disabled: PropTypes.bool,
      path: PropTypes.string,
    })
  ).isRequired,
  currentStep: PropTypes.number.isRequired,
};

Sidebar.defaultProps = {};

export default Sidebar;
